module.exports = __webpack_public_path__ + "img/roma.d8531292.png";